'use strict';

exports.__esModule = true;

var _ramda = /*#__PURE__*/require('ramda');

/**
 * A function that returns `null`.
 *
 * @func stubNull
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.6.0|v1.6.0}
 * @category Function
 * @sig ... -> null
 * @return {null}
 * @example
 *
 * RA.stubNull(); //=> null
 * RA.stubNull(1, 2, 3); //=> null
 */
var stubNull = /*#__PURE__*/(0, _ramda.always)(null);

exports.default = stubNull;


//////////////////
// WEBPACK FOOTER
// ./~/ramda-adjunct/lib/stubNull.js
// module id = 944
// module chunks = 168707334958949